import {
  CountryCode as LibCountryCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";

export const isValidPhoneNumber = (
  phoneNumber: string,
  countryCode?: LibCountryCode,
) => {
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, countryCode);
  return parsedNumber?.isValid() ?? false;
};

export const normalizePhoneNumber = (
  phoneNumber: string,
  countryCode?: LibCountryCode,
) => {
  const sanitizedPhoneNumber = phoneNumber
    .replace(/\s+/g, "")
    .replace(/(?!^)\+/g, "");
  const parsedNumber = parsePhoneNumberFromString(
    sanitizedPhoneNumber,
    countryCode,
  );

  return parsedNumber?.isValid() ? parsedNumber.number : sanitizedPhoneNumber;
};
